import { render, staticRenderFns } from "./ConvertionsDetail.vue?vue&type=template&id=3550b214&scoped=true&"
import script from "./ConvertionsDetail.vue?vue&type=script&lang=js&"
export * from "./ConvertionsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConvertionsDetail.vue?vue&type=style&index=0&id=3550b214&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3550b214",
  null
  
)

export default component.exports